const getError = ({ inputType, validations }) => {
  let validationWithMessage = {};

  if (validations?.required) {
    if (inputType === "radio") {
      validationWithMessage.required = "Bitte wählen Sie eine Option aus, um fortzufahren.";
    } else {
      validationWithMessage.required = "Diese Eingabe ist erforderlich.";
      validationWithMessage.pattern = {
        value: /(.|\s)*\S(.|\s)*/,
        message: "Diese Eingabe ist erforderlich.",
      };
    }
  }

  if (validations?.email) {
    validationWithMessage.pattern = {
      value: /^\S+@\S+\.\S+$/,
      message: "Bitte überprüfen Sie Ihre E-Mail.",
    };
  } else if (validations?.tel) {
    validationWithMessage.pattern = {
      value: /\(?(\+)?\(?(0|49)?\)?[ ()]?([- ()]?\d[- ()]?){10,14}/,
      message: "Bitte überprüfen Sie Ihre Telefonnummer.",
    };
  }

  return validationWithMessage;
};

export { getError };
